import './TodayAppointments.scss';

import { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';

import { loadTodaysAppointments } from 'actions/appointments';
import { loadProvider } from 'actions/provider';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { List } from 'organisms/Appointments/List';
import GroomersDropdown from 'organisms/GroomersDropdown';
import { UserAvatarExtraSmall } from 'organisms/GroomersDropdown/UserAvatar';
import GeneralLoader from 'organisms/Loaders/GeneralLoader';
import NewAppointmentButton from 'organisms/NewAppointmentButton';

function TodaysAppointments() {
  const dispatch = useDispatch();
  const { uuid: isAdmin } = useSelector((state) => state.adminUser);
  const { selectedGroomer } = useSelector((state) => state.ui);
  const {
    name: providerName,
    providerLoading,
    uuid: providerUuid,
  } = useSelector((state) => state.provider);
  const { appointments, isLoading } = useSelector(
    (state) => state.providerAppointments
  );
  const hasLoadedFirstAppointments = useRef(false);
  const { width } = useWindowDimensions();
  const isMobile = width <= 600;

  useEffect(() => {
    let intervalId = null;

    dispatch(loadProvider(providerUuid)).then(({ success }) => {
      const fetchTodaysData = async () => {
        if (success) {
          dispatch(loadTodaysAppointments()).then(() => {
            if (!hasLoadedFirstAppointments.current)
              hasLoadedFirstAppointments.current = true;
          });
        }
      };

      fetchTodaysData();

      intervalId = setInterval(() => {
        fetchTodaysData();
      }, 5000);
    });

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (hasLoadedFirstAppointments.current) {
      dispatch(loadTodaysAppointments());
    }
  }, [selectedGroomer.uuid]);

  return (
    <div className="page-container today-appointments">
      <Helmet title="Appointments | PawCare" />
      <div className="today-appointments-header flex-row justify-between">
        <h1>{`${isAdmin ? `${providerName}'s t` : 'T'}oday${
          isMobile ? '' : "'s appointments"
        }`}</h1>
        <div className="today-appointments-actions flex-row gap-24">
          <NewAppointmentButton />
          <GroomersDropdown Element={UserAvatarExtraSmall} />
        </div>
      </div>
      <div className="today-appointments-content">
        {!hasLoadedFirstAppointments.current &&
        (isLoading || providerLoading) ? (
          <GeneralLoader />
        ) : (
          <List
            key={Math.random()}
            items={appointments}
            isLoading={isLoading}
          />
        )}
      </div>
    </div>
  );
}

export default TodaysAppointments;
